const path = require('path');
const slash = require('slash');


module.exports = function(input) {
  let filePath = path.normalize(input);
  filePath = slash(filePath);
  return filePath;
};
